import React, { useEffect } from 'react';
import { Layout } from './Layout';
import { useAuth } from './AuthContext';

export const Domotica = () => {
    const [showGarageOpen, setShowGarageOpen] = React.useState(false);
    const [showOutdoorGateOpen, setShowOutdoorGateOpen] = React.useState(false);
    const [showBoilerOpen, setShowBoilerOpen] = React.useState(false);
    const [temperatureBoiler, setTemperatureBoiler] = React.useState(null);
    const [activeBoiler, setActiveBoiler] = React.useState(1);
    const [loadingBoiler, setLoadingBoiler] = React.useState(true);
    const { token } = useAuth();

    useEffect(() => {
        if (loadingBoiler) {
            populateTemperatureAndActiveBoiler();
        }
    });

    const askGarageOpen = async () => {
        setShowGarageOpen(true);
    }

    const abortGarageOpen = async () => {
        setShowGarageOpen(false);
    }

    const openGarage = async () => {
        setShowGarageOpen(false);

        const url = "webiopi/setgarage";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Token': token }
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                    return '';
                }
                return response.text();
            })
            .then((data) => {
            })
            .catch(err => {
                console.log(err);
            });
    };

    const askOutdoorGateOpen = async () => {
        setShowOutdoorGateOpen(true);
    }

    const abortOutdoorGateOpen = async () => {
        setShowOutdoorGateOpen(false);
    }

    const openOutdoorGate = async () => {
        setShowOutdoorGateOpen(false);

        const url = "webiopi/SetOutdoorGate";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Token': token }
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                    return '';
                }
                return response.text();
            })
            .then((data) => {
            })
            .catch(err => {
                console.log(err);
            });
    };

    const askBoilerOpen = async () => {
        setShowBoilerOpen(true);
    }

    const abortBoilerOpen = async () => {
        setShowBoilerOpen(false);
    }

    const openBoiler = async () => {
        setShowBoilerOpen(false);

        const url = "webiopi/SetBoiler";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Token': token }
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                    return '';
                }
                return response.text();
            })
            .then((data) => {
                setActiveBoiler(parseInt(data));
            })
            .catch(err => {
                console.log(err);
            });
    };

    const openPipeHeat = async () => {
        setShowBoilerOpen(false);

        const url = "webiopi/SetPipesHeat";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Token': token }
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                    return '';
                }
                return response.text();
            })
            .then((data) => {
            })
            .catch(err => {
                console.log(err);
            });
    };

    const populateTemperatureAndActiveBoiler = async () => {
        const url = "webiopi/GetBoilerTemperatureAndActive";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Token': token }
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                    window.location = '/login';
                    return '';
                }
                return response.json();
            })
            .then((data) => {
                setTemperatureBoiler(data.temperature);
                setActiveBoiler(data.active);
            })
            .catch(err => {
                setTemperatureBoiler(null);
                setActiveBoiler(null);
                console.log(err);
            });
        setLoadingBoiler(false);
    }

    const renderTemperatureBoiler = () =>  {
        return (temperatureBoiler > 0 
            ? '(' + temperatureBoiler + 'º)'
            : '(????)'
        );
    };

    const renderActiveBoiler = () => {
        return (activeBoiler === 0
            ? '(Activa)'
            : (activeBoiler === 1 ? '(Desligada)' : '(Sem conexão)')
        );
    };

    let temperatureBoilerRender = loadingBoiler
        ? <span>(....º)</span>
        : renderTemperatureBoiler();

    let activeBoilerRender = loadingBoiler
        ? <span>(?????)</span>
        : renderActiveBoiler();

    let showYesorNoOutdoorGate = showOutdoorGateOpen
        ?
        <div className="buttonAction">
            <button className="btn btn-outline-success btn-lg full-width" onClick={openOutdoorGate}>Abrir/Fechar Portão</button>
            <button className="btn btn-outline-secondary btn-lg full-width" onClick={abortOutdoorGateOpen}>Sair</button>
        </div>
        : "";

    let showYesorNoGarage = showGarageOpen
        ?
        <div className="buttonAction">
            <button className="btn btn-outline-success btn-lg full-width" onClick={openGarage}>Abrir/Fechar Garagem</button>
            <button className="btn btn-outline-secondary btn-lg full-width" onClick={abortGarageOpen}>Sair</button>
        </div>
        : "";

    let showYesorNoBoiler = showBoilerOpen
        ?
        <div className="buttonAction">
            {activeBoiler === 1
                ? <button className="btn btn-outline-success btn-lg full-width" onClick={openBoiler}>Ligar Caldeira</button>
                : <button className="btn btn-outline-success btn-lg full-width" onClick={openBoiler}>Desligar Caldeira</button>
            }
            <button className="btn btn-outline-success btn-lg full-width" onClick={openPipeHeat}>Aquecer Tubagem</button>
            <button className="btn btn-outline-secondary btn-lg full-width" onClick={abortBoilerOpen}>Sair</button>
        </div>
        : "";

    return (
        <Layout>
            <div>
                <h1 id="gate">
                    <button className="btn btn-primary btn-lg full-width" onClick={askOutdoorGateOpen}>
                        Portão
                    </button>
                    {showYesorNoOutdoorGate}
                </h1>
                <br />
                <br />
                <h1 id="garage">
                    <button className="btn btn-primary btn-lg full-width" onClick={askGarageOpen}>
                        Garagem
                    </button>
                    {showYesorNoGarage}
                </h1>
                <br />
                <br />
                <h1 id="tabelLabel">
                    <button className={"btn btn-primary btn-lg full-width " + (activeBoiler == 0 ? "red" :"")} onClick={askBoilerOpen}>
                        Caldeira {temperatureBoilerRender} {activeBoilerRender}
                    </button>
                    {showYesorNoBoiler}
                </h1>
            </div>
        </Layout>
    );
}
